<!-- incoming filter editor -->
<template>
    <div v-if="!loading"> 
        <form @submit.prevent="apply()">
        <div class="modal fade show" style="display: block" role="dialog">
            <div class="modal-dialog modal-dialog-scrollable modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{translate('incomingDoc.filterEditor.addFilter')}}</h5>
                        <a href="#void" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="close()">
                            <span aria-hidden="true">&times;</span>
                        </a>
                    </div>
                    <div class="modal-body">
                        <div style="padding:30px 10px 15px 10px; height:max-content;">
                            <div>
                                <div>
                                    <div class="col-md-3">
                                        <label for="External.FirstName" class="col-md-8 col-form-label">{{translate('incomingDoc.filterEditor.filterName')}}</label>
                                        <div class="col-md-8">
                                            <input type="text" @input="checkInput('filterName',$event)" class="form-control" style="width: 250px !important" v-model="filter.filterName"
                                                required>
                                        </div>
                                    </div>
                                    <div class="addButton">
                                        <button type="button" class="btn btn-primary btn-kural-ekle" @click="addRule">{{translate('incomingDoc.filterEditor.addRule')}}</button>
                                    </div>
                                    <div class="filter-container" v-for="(a, counter) in filter.conditions"
                                        v-bind:key="counter">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="col-md-8 col-form-label">{{translate('incomingDoc.filterEditor.filterType')}}</label>
                                                    <div class="col">
                                                        <select v-model="a.VariableName" class="form-control" required>
                                                            <option value="Sender">{{translate('incomingDoc.filterEditor.filterTypes.sender')}}</option>
                                                            <option value="DocumentType">{{translate('incomingDoc.filterEditor.filterTypes.documentType')}}</option>
                                                            <option value="DocumentSubject">{{translate('incomingDoc.filterEditor.filterTypes.documentSubject')}}</option>
                                                            <option value="HasAttachment">{{translate('incomingDoc.filterEditor.filterTypes.hasAttachment')}}</option>
                                                            <option value="AttachmentName">{{translate('incomingDoc.filterEditor.filterTypes.attachmentName')}}</option>
                                                            <option value="AttachmentExtension">{{translate('incomingDoc.filterEditor.filterTypes.attachmentExtension')}}</option>
                                                            <option value="DocumentExtension">{{translate('incomingDoc.filterEditor.filterTypes.documentExtension')}}</option>
                                                            <option value="DocumentName">{{translate('incomingDoc.filterEditor.filterTypes.documentName')}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <label class="col-md-8 col-form-label">{{translate('incomingDoc.filterEditor.variableMatchType')}}</label>
                                                <div class="col">
                                                    <select v-model="a.VariableMatchType" class="form-control" required>
                                                        <option value="Equal">{{translate('incomingDoc.filterEditor.variableMatchTypes.equal')}}</option>
                                                        <option value="NotEqual">{{translate('incomingDoc.filterEditor.variableMatchTypes.notEqual')}}</option>
                                                        <option v-if="a.VariableName != 'HasAttachment' && a.VariableName != 'DocumentType'" value="Contains">{{translate('incomingDoc.filterEditor.variableMatchTypes.contains')}}</option>
                                                        <option v-if="a.VariableName != 'HasAttachment' && a.VariableName != 'DocumentType'" value="NotContains">{{translate('incomingDoc.filterEditor.variableMatchTypes.notContains')}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div v-if="a.VariableName == 'HasAttachment'">
                                                    <label class="col-md-8 col-form-label">{{translate('incomingDoc.filterEditor.filterValue')}}</label>
                                                    <div class="col-md-8">
                                                        <select v-model="a.VariableValue" class="form-control" required>
                                                            <option value="Var">{{translate('incomingDoc.filterEditor.filterValueVar')}}</option>
                                                            <option value="Yok">{{translate('incomingDoc.filterEditor.filterValueYok')}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div v-if="a.VariableName == 'DocumentType'">
                                                    <label class="col-md-8 col-form-label">{{translate('incomingDoc.filterEditor.filterValue')}}</label>
                                                    <div class="col-md-8">
                                                        <select v-model="a.VariableValue" class="form-control" required>
                                                            <option value="Kep">KEP</option>
                                                            <option value="Uets">UETS</option>
                                                            <option value="Pdf">PDF</option>
                                                            <option value="Xml">XML</option>
                                                            <option value="Ftp">FTP</option>
                                                            <option value="Email">Email</option>
                                                            <option value="Other">Diğer</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div v-if="a.VariableName !== 'DocumentType' && a.VariableName!=='HasAttachment' ">
                                                    <label class="col-md-8 col-form-label">{{translate('incomingDoc.filterEditor.filterValue')}}</label>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control" @input="checkFilterValue('VariableValue',$event, counter)" style="width: 250px !important"  v-model="a.VariableValue"
                                                            required>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div class="col-md-1 d-flex justify-content-end align-items-center" style="margin-top: 15px !important">
                                                <button @click="deleteRule(counter)" type="button" class="deleteButton">
                                                    <svg width="1.5em" height="1.5em" viewBox="0 0 16 16"
                                                        class="bi bi-trash text-danger" fill="currentColor"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                        <path fill-rule="evenodd"
                                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                    </svg>
                                                </button>
                                            </div>
                                            
                                        </div>
                                        <div class="baglantiContainer" v-if=getBaglantiDisplay(counter)>
                                            <div class="baglantiRow">
                                                <label class="baglantiLabel">{{translate('incomingDoc.filterEditor.connection')}}</label>
                                                <select v-model="a.NextConditionConnectionType" class="form-control">
                                                    <option value="And">{{translate('incomingDoc.filterEditor.connectionAnd')}}</option>
                                                    <option value="Or">{{translate('incomingDoc.filterEditor.connectionOr')}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="form-group col">
                                            <label>{{translate('incomingDoc.filterEditor.categories')}}</label>
                                            <select-multiple :autocomplete="true" v-model="filter.categoryIds" :list="categories" :emptyLabel="this.loadingLabel">
                                                <template slot-scope="{ item }">
                                                    <div v-if="item">
                                                        <small class="float-right badge">{{item.Type | documentType }}</small>
                                                    {{item.Name}}
                                                    </div>
                                                    <div v-else>
                                                        <span>{{translate('loading')}}</span>
                                                    </div>
                                                </template>
                                            </select-multiple>
                                        </div>
                                        <div class="col">
                                            <label>{{translate('incomingDoc.filterEditor.targetDepartments')}}</label>
                                            <select-multiple :autocomplete="true" :list="departments" v-model="filter.recipients.DepartmentIds"></select-multiple>
                                        </div>
                                        <div class="col">
                                            <label>{{translate('incomingDoc.filterEditor.targetUsers')}}</label>
                                            <select-multiple v-model="filter.recipients.UserIds" :autocomplete="true"
                                                :list="userList" :getText="x => x.FullName"
                                                :emptyLabel="this.loadingLabel" class="user-select-input">
                                                <template slot-scope="{ item }">
                                                    <div v-if="item" class="d-flex align-items-center">
                                                        <div class="d-flex w-100 justify-content-between">
                                                            <span>{{ item.FullName }}</span>
                                                            <small class="text-right align-items-center">{{
                                                                    item.Title.Name
                                                            }}</small>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <span>{{translate('loading')}}</span>
                                                    </div>
                                                </template>
                                            </select-multiple>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex justify-content-center align-items-center">
                                        <div class="col-md-auto">
                                            <label>
                                                <input type="checkbox" v-model="filter.notifyEnabled" />
                                                {{translate('incomingDoc.filterEditor.sendInformationMail')}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="hidden">
                                        <div class="col-md-auto hidden">
                                            <label hidden>
                                                <input type="checkbox" v-model="filter.isActive" hidden />
                                                {{translate('incomingDoc.filterEditor.active')}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer align-content-center justify-content-between">
                        <button type="button" class="btn btn-outline-secondary" @click="close()" data-dismiss="modal">{{translate('cancel')}}</button>
                        <button type="submit" class="btn btn-primary">{{translate('okay')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    </div>
    
</template>

<script>
import selectMultiple from '../../components/SelectMultiple.vue'

export default {
    components: {
        selectMultiple
    },
    created() {
        this.loading = true;
        this.getDepartments({ predicate: "IsActive= true" })
            .then(x => {
                this.departments = x.Result;
            }).catch(x => {
                console.log("Departman listesi yüklenemedi:", x);
            });

        this.getUsers({
            predicate: "IsActive= true",
            // DepartmentIds: [this.$route.params.id],
        }).then(x => {
            this.userList = x.Result;
            this.loadingLabel = this.emptyLabel;
        });
        this.getCategories({predicate: "IsActive=true"})
            .then(x=> {
            this.categories = x.Result;
            console.log("c",this.categories);
            this.loading = false;
        })
        this.filter = Object.assign({}, this.value); //JSON.parse(JSON.stringify(this.value));
        // if(this.filter.Id == this.filterTemplate.Id)
        //     this.filter = this.filterTemplate;
        console.log("val",this.value);
        console.log("filter",this.filter);
        
        
    },
    props: {
        value: Object,
    },
    data() {
        return {
            filter:{
                Id: window.emptyObjectId,
                conditions: [{
                    VariableName: null,
                    VariableMatchType: null,
                    NextConditionConnectionType: null,
                    VariableValue: null,
            }],
                recipients: {
                    UserIds: [],
                    DepartmentIds: []
                },
                filterName: "",
                isActive: true,
                notifyEnabled: false
            },            
            // filters: [
            //     {
            //         VariableName: null,
            //         VariableMatchType: null,
            //         NextConditionConnectionType: null,
            //         VariableValue: null,
            //     },
            // ],

            loadingLabel: this.translate('listFetching'),
            emptyLabel: this.translate('emptyLabel'),
            departments: [],
            userList: null,
            categories: [],
            loading: true
        }
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.filter, value, editedText)
            } else {
                this.$set(this.filter, value, event.target.value)
            }
        },
        checkFilterValue(value, event, index) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.filter.conditions[index], value, editedText)
            } else {
                this.$set(this.filter.conditions[index], value, event.target.value)
            }
        },
        getBaglantiDisplay(i) {
            var size = this.filter.conditions.length;
            //console.log(i + "-" + size);
            if (i < size - 1)
                return true;
            else
                return false;
        },
        addRule() {
            this.filter.conditions.push({
                VariableName: '',
                VariableMatchType: '',
                VariableValue: '',
                NextConditionConnectionType: '',
            })
        },
        deleteRule(counter) {
            this.filter.conditions.splice(counter, 1);
        },
        close() {
            this.$emit('cancel');
        },
        apply() {
            console.log("apply1")
            if(this.filter.recipients.UserIds.length == 0 && this.filter.recipients.DepartmentIds.length == 0){
                alert(this.translate('errors.emptyTargetDeparmentOrUser'))
            }else{
                this.filter.conditions.forEach(x => {
                    if(!x.NextConditionConnectionType || x.NextConditionConnectionType == '')
                    x.NextConditionConnectionType = "And";
                });
                console.log(this.filter);
                this.$emit('input', this.filter);
                this.$emit('apply', this.filter);
            }
            
        },
    },
    computed: {
        IsListAllUsers() {
            return this.$store.state.approvalUserEditor.ListAllusers;
        },
    }
}
</script>

<style scoped>
/* .bg {
    background-color: rgba(7, 3, 24, 0.452);
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0
} */
.deleteButton {
    border: 1px solid transparent;
    background-color: transparent;
    border-radius: 3px;
    transition: 0.4s;
    font-size: 12px;
}

.deleteButton:hover {
    border: 1px solid rgb(235, 159, 159);
    background-color: rgb(235, 159, 159);
}

.btn-kural-ekle{
    margin-bottom: 20px;
}

.addButton {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.baglantiContainer{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.baglantiRow{
    display: flex;
    align-items: center;
    justify-content: center;
}
.baglantiLabel{
    margin: 15px 15px;
}
</style>